import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import connect from "react-redux/es/connect/connect";
import {
    FacebookIcon,
    TwitterIcon,
    PinterestIcon,
    GooglePlusIcon,
    FacebookShareButton,
    TwitterShareButton,
    PinterestShareButton,
    GooglePlusShareButton
} from "react-share";

class ModalShare extends React.Component {

    render() {
        return (
            <div>
                <Modal size={'xs'} isOpen={this.props.openModal} toggle={this.props.toggle} className={this.props.className}>
                    <ModalHeader toggle={this.toggle}>Distribuie...</ModalHeader>
                    <ModalBody>
                        <FacebookShareButton url={window.location.href}>
                            <span className={"share-icon"}>
                                <FacebookIcon size={32} />
                            </span>
                        </FacebookShareButton>

                        <TwitterShareButton url={window.location.href}>
                            <span className={"share-icon"}>
                                <TwitterIcon size={32} />
                            </span>
                        </TwitterShareButton>

                        <PinterestShareButton url={window.location.href} media={this.props.poster}>
                            <span className={"share-icon"}>
                                <PinterestIcon size={32} />
                            </span>
                        </PinterestShareButton>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={this.props.toggle}>Inchide</Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}

const mapStateToProps = state => ({

});
export default connect(mapStateToProps, {})(ModalShare);


// WEBPACK FOOTER //
// ./src/SHARED/components/modalsharing/modalshare.component.js